// extracted by mini-css-extract-plugin
export default {"label":"Label_label__SgjXW","title":"Label_title__uR6LC","required":"Label_required__S0s7h","errorWrapper":"Label_errorWrapper__OtWx4","errorText":"Label_errorText__lFzmu"};